import React, { useState, useEffect } from 'react';
import { ordenarArreglo } from '../../../config/functions';
import { LoaderES } from '../../LoaderES';
import { Filtrar } from '../../Filtrar';
import { Pagination } from '../../Pagination';
import { ModalVarEdit } from './ModalVarEdit';
import { ThOrdenable } from './ThOrdenable';
import { Collapse } from 'react-bootstrap';

const Variables = ({ 
  broken, collapsed, mobile, variables, setVariables, user, colors,
  // Tab props (solo desktop)
  openTabs, setOpenTabs, activeTabId, setActiveTabId, showRigSelector, setShowRigSelector, theme
}) => {

  const [documentosFiltrados, setDocumentosFiltrados] = useState([]);
  const [variable, setVariable] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [open, setOpen] = useState(null);
  const [registrosPorPagina, setRegistrosPorPagina] = useState(15);
  const [paginaActual, setPaginaActual] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(0)
  const [registrosPaginaActual, setRegistrosPaginaActual] = useState([])

  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const [filtro, setFiltro] = useState(''); // Estado elevado del filtro

  // Estado del ordenamiento actual
  const [columnaOrden, setColumnaOrden] = useState('vr_var_tag');
  const [direccionOrden, setDireccionOrden] = useState('asc');

  const handleOrdenar = (columna) => {
    const nuevaDireccion = (columnaOrden === columna && direccionOrden === 'asc') ? 'desc' : 'asc';
    setColumnaOrden(columna);
    setDireccionOrden(nuevaDireccion);
    setPaginaActual(1);

    ordenarArreglo(columna, variables, setVariables, nuevaDireccion);
    if (documentosFiltrados && documentosFiltrados.length > 0) {
      ordenarArreglo(columna, documentosFiltrados, setDocumentosFiltrados, nuevaDireccion);
    }
  };

  //---------------------------------------------

  useEffect(() => { 
    if (!filtro) {
      setDocumentosFiltrados(variables);
    }
  }, [variables, filtro])

  //---------------------------------------------

  useEffect(() => {
    const newTotalPaginas = Math.ceil(documentosFiltrados.length / registrosPorPagina)
    setTotalPaginas(newTotalPaginas)
    
    // Ajustar paginaActual si está fuera de rango después de actualizar
    if (paginaActual > newTotalPaginas && newTotalPaginas > 0) {
      setPaginaActual(newTotalPaginas)
    }
  }, [documentosFiltrados, registrosPorPagina, paginaActual])

  useEffect(() => {
    const inicio = (paginaActual - 1) * parseInt(registrosPorPagina)
    const fin = inicio + parseInt(registrosPorPagina)
    setRegistrosPaginaActual(documentosFiltrados.slice(inicio, fin))
  }, [paginaActual, totalPaginas, documentosFiltrados, registrosPorPagina])

  //---------------------------------------------

  return (
    <>
      {(variables.length === 0 || isLoading)
        ? <LoaderES />
        : <>
          <Filtrar
            documentos={variables}
            setDocumentosFiltrados={setDocumentosFiltrados}
            setRegistrosFiltrados={setRegistrosPaginaActual}
            registrosPorPagina={registrosPorPagina}
            filtro={filtro}
            setFiltro={setFiltro}
            colors={colors}/>

          {mobile
            ? <>
              {registrosPaginaActual?.map((vrbl, index) => (
                <div key={vrbl.nb_var_idn}>
                  <table className="table table-sm table-hover table-striped mb-0">
                    <thead style={{ fontSize: '14px', color: colors.colorFont }}>
                      <tr>
                        <th style={{ width: '50px', resize: 'none' }}>
                          <button className="btn  fa-solid fa-chevron-down btn-sm"
                            style={{ color: colors.colorFont || '#000000' }}
                            onClick={() => setOpen(open === index ? null : index)}
                            aria-controls={"collapse-item-" + index}
                            aria-expanded={open === index}
                          />
                        </th>
                        <th style={{ width: '150px', resize: 'none' }}>
                          {vrbl.vr_var_nom}
                          {vrbl.vr_var_witsml_nemo && (
                            <span className="ms-1" style={{ fontSize: '10px', opacity: 0.8 }}>
                              [{vrbl.vr_var_witsml_nemo}]
                            </span>
                          )}
                        </th>
                        <th style={{ width: '50px', resize: 'none' }} className='text-end'>
                          <button className='btn btn-sm me-2'
                            style={{ color: colors.colorFont || '#000000' }}
                            onClick={() => {
                              setVariable(vrbl)
                              setShowModal(true)
                            }}>
                            <i className="fa-solid fa-pencil" />
                          </button>
                        </th>
                      </tr>
                    </thead>
                  </table>


                  <Collapse in={open === index}>
                    <div id={"collapse-item-" + index} className="mt-2">
                      <div className="card card-body" style={{ backgroundColor: colors.colorBg || '#FFFFFFF', borderColor: colors.colorFont || '#000000' }}>
                        <table className="table table-sm" style={{ color: colors.colorFont || '#000000' }}>
                          <tbody style={{ fontSize: '12px' }}>

                            <tr>
                              <td>Variable: </td>
                              <td>{vrbl.vr_var_nom}</td>
                            </tr>

                            <tr>
                              <td>WitsML:</td>
                              <td>{vrbl.vr_var_witsml_nemo ? `${vrbl.vr_var_witsml_nemo} (${vrbl.vr_var_witsml_umd})` : '-'}</td>
                            </tr>

                            <tr>
                              <td>Desc. WitsML:</td>
                              <td>{vrbl.vr_var_witsml_des || '-'}</td>
                            </tr>

                            <tr>
                              <td>UM:</td>
                              <td>{vrbl.vr_var_umd}</td>
                            </tr>

                            <tr>
                              <td>Descripción:</td>
                              <td style={{ minWidth: '60px', maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', resize: 'none' }}>
                                <span className="truncate-text">
                                  {vrbl.vr_var_des.length > 50 ? vrbl.vr_var_des.slice(0, 50) + '...' : vrbl.vr_var_des}
                                </span>
                              </td>
                            </tr>

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Collapse>

                </div>
              ))}
            </>
            : <div className="table-responsive mt-3">
              <table className="table table-hover table-sm align-middle table-bordered" id='myTable'
                style={{ color: colors.colorFont || '#000000' }}>
                <thead>
                  <tr>
                    <th scope="col" style={{ width: '40px' }}></th>
                    <ThOrdenable
                      columna="vr_var_tag"
                      titulo="TAG"
                      tipo="num"
                      columnaOrden={columnaOrden}
                      direccionOrden={direccionOrden}
                      onOrdenar={handleOrdenar}
                      colors={colors}
                    />
                    <ThOrdenable
                      columna="vr_var_nom"
                      titulo="Variable"
                      tipo="alpha"
                      columnaOrden={columnaOrden}
                      direccionOrden={direccionOrden}
                      onOrdenar={handleOrdenar}
                      colors={colors}
                    />
                    <ThOrdenable
                      columna="vr_var_witsml_nemo"
                      titulo="WitsML"
                      tipo="alpha"
                      className="text-center"
                      columnaOrden={columnaOrden}
                      direccionOrden={direccionOrden}
                      onOrdenar={handleOrdenar}
                      colors={colors}
                    />
                    <ThOrdenable
                      columna="vr_var_witsml_des"
                      titulo="Descripción WitsML"
                      tipo="alpha"
                      columnaOrden={columnaOrden}
                      direccionOrden={direccionOrden}
                      onOrdenar={handleOrdenar}
                      colors={colors}
                    />
                    <ThOrdenable
                      columna="vr_var_umd"
                      titulo="Unidad de Medida"
                      tipo="alpha"
                      columnaOrden={columnaOrden}
                      direccionOrden={direccionOrden}
                      onOrdenar={handleOrdenar}
                      colors={colors}
                    />
                    <ThOrdenable
                      columna="vr_var_des"
                      titulo="Descripción"
                      tipo="alpha"
                      columnaOrden={columnaOrden}
                      direccionOrden={direccionOrden}
                      onOrdenar={handleOrdenar}
                      colors={colors}
                    />
                  </tr>
                </thead>
                <tbody>
                  {variables && variables.length > 0 ? registrosPaginaActual.map(vrbl => (
                    <tr key={vrbl.nb_var_idn} style={{ fontSize: '11px' }}>
                      <td>
                        <button className='btn btn-sm fa-solid fa-pencil'
                          onClick={() => {
                            setVariable(vrbl)
                            setShowModal(true)
                          }}
                          style={{ color: colors.colorFont || '#000000' }}
                        >
                        </button>
                      </td>
                      <td>{vrbl.vr_var_tag}</td>
                      <td>{vrbl.vr_var_nom}</td>
                      <td className="text-center font-monospace">
                        {vrbl.vr_var_witsml_nemo ? (
                          <span
                            title={`Factor: ${vrbl.vr_var_witsml_conv_factor || 1.0} (${vrbl.vr_var_witsml_umd})`}
                            style={{ fontWeight: 'bold' }}
                          >
                            {vrbl.vr_var_witsml_nemo}
                          </span>
                        ) : (
                          <span style={{ opacity: 0.3 }}>-</span>
                        )}
                      </td>
                      <td>
                        {vrbl.vr_var_witsml_des ? (
                          <span>
                            {vrbl.vr_var_witsml_des}
                            {vrbl.vr_var_witsml_umd && (
                              <small className="text-muted ms-1">({vrbl.vr_var_witsml_umd})</small>
                            )}
                          </span>
                        ) : (
                          <span style={{ opacity: 0.3 }}>-</span>
                        )}
                      </td>
                      <td>{vrbl.vr_var_umd}</td>
                      <td>{vrbl.vr_var_des}</td>
                    </tr>
                  )) : null}
                </tbody>
              </table>
            </div>
          }

          <Pagination
            paginaActual={paginaActual}
            totalPaginas={totalPaginas}
            setPaginaActual={setPaginaActual}
            registrosPorPagina={registrosPorPagina}
            setRegistrosPorPagina={setRegistrosPorPagina}
            documentosFiltrados={documentosFiltrados}
            broken={broken}
            collapsed={collapsed}
            mobile={mobile}
            colors={colors}
          />

          <ModalVarEdit
            variableAll={variable}
            variables={variables}
            show={showModal}
            setIsLoading={setIsLoading}
            handleClose={handleCloseModal}
            setVariables={setVariables}
            user={user}
          />

        </>
      }
    </>
  )
}

export default Variables
